module.exports = __webpack_public_path__ + "static/media/logo-fjc.ceb00a9c.webp";